import React from 'react';

import strings from 'app/locales/results';

import styles from './styles.css';

const ActionText = ({ goodGuyPercent }) => (
  <div className={styles.container}>
    <p className={styles.resultsText}>
      {strings.resultHeadline(goodGuyPercent)}
    </p>
    <p className={styles.text}>{strings.resultText(goodGuyPercent)}</p>
  </div>
);

export default ActionText;



// WEBPACK FOOTER //
// ./src/components/ResultsContainer/ActionText/index.js